import styled from "styled-components";
import { BreakPoints, Colors, FontFamily } from "../../shared/utils/Theme";

const StyledCategoryMenu = styled.div`
  display: flex;
  padding: 0 48px;
  background-color: ${Colors.interactiveBackground};
  position: relative;
  .category-menu {
    display: inline;
    align-items: center;
    gap: 10px;
    padding: 10px 25px;
    border-bottom: 5px solid transparent;
    cursor: pointer;
    &:hover {
      border-bottom: 5px solid ${Colors.interactive};
    }
  }
  .category-head {
    font-family: ${FontFamily.SourceSansPro};
    font-size: 0.99vw;
    font-weight: 600;
    text-align: left;
    color: ${Colors.interactive};
    cursor: pointer;
  }
  .research-tools {
    font-family: ${FontFamily.SourceSansPro};
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    height: 2rem;
    width: 10vw;
    white-space: nowrap;
  }
  @media (min-width: ${BreakPoints.MediumDevices}) and (max-width: ${BreakPoints.LargeDevices}) {
    .category-head {
      font-size: 0.85vw;
    }
  }
  @media (max-width: ${BreakPoints.MediumDevices}) {
    display: none;
  }
`;
export default StyledCategoryMenu;
